// Copyright 2025. WebPros International GmbH. All rights reserved.

import { Translate } from '@plesk/ui-library';
import { Dialog } from 'common/components/Dialog/Dialog';
import { getStatus } from 'common/api/resources/ComputeResource';
import { COMPUTE_RESOURCE_STATUS } from 'admin/computeResource/constants';
import ErrorMessage from 'admin/disasterRecovery/components/ErrorMessage/ErrorMessage';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    status?: COMPUTE_RESOURCE_STATUS;
}

export default function StatusConflictDialog({
    isOpen,
    onClose,
    status,
}: IProps) {
    return (
        <Dialog
            heading={<Translate content="disasterRecovery.readinessStatus.destinationComputeResources.table.status" />}
            closeHandler={onClose}
            isOpen={isOpen}
            size={'sm'}
        >
            {status && (
                <ErrorMessage>
                    <Translate
                        content="disasterRecovery.readinessStatus.destinationComputeResources.dialogs.status"
                        params={{ status: getStatus(status) }}
                    />
                </ErrorMessage>
            )}
        </Dialog>
    );
}